module.exports = __webpack_public_path__ + "static/media/arrow_question_active.891c46ac.svg";